import { render, staticRenderFns } from "./EditSocialCard.vue?vue&type=template&id=211a6609"
import script from "./EditSocialCard.vue?vue&type=script&lang=js"
export * from "./EditSocialCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports